/**
* @file Component with standard form functionality for showing a child entity in a parent child relation.
* @author Tom Verschoore de la Houssaije
*/
import * as tslib_1 from "tslib";
import { FormBase } from '../form/form.base';
/**
 * Component with standard form functionality for showing a child entity in a parent child relation.
 */
var FormChildBase = /** @class */ (function (_super) {
    tslib_1.__extends(FormChildBase, _super);
    /**
     * Constructs a FormChildBase
     * @param configurationsService Service to get the configuration of this component.
     * @param breezeService Service to access entities form the backend entity api.
     */
    function FormChildBase(breezeService, translateService, alertsService, resourceService) {
        var _this = _super.call(this, breezeService, null, null, translateService, alertsService, resourceService) || this;
        /**
         * Gets sets the master entity of shown master/parent detail/child relation.
         * Is used to extend the logic of FormChildComponent.getIsReadOnly() method.
         * @type {Entity}
         * @memberOf FormChildComponent
         */
        _this.master = null;
        return _this;
    }
    /** Sets the entity key of the child entity shown. */
    /* Waarschijnlijk kan deze code weg zodat we terug vallen op FormBase code.
       Weghalen lost in ieder geval het probleem op wanneer we een PlanItem willen tonen in een FormChild (dag ruil verzoeken)
       Als versie 12 geaccepteerd is kan deze code weg. (Weten we zeker dat we geen ander gedrag willen voor FormChildBase)

    @Input() public set entityKey(value: string) {
        if (!value) {
            this.entityKeyValue = undefined;
            this.item = null;
            return;
        }

        if (!this.entityType) {
            return;
        }

        this.entityKeyValue = value;
        this.getEntityWith(value);
    }
    */
    /**
     * Cancels all the made changes and closes the sidebar.
     */
    FormChildBase.prototype.cancelItem = function () {
        if (this.item) {
            this.item.entityAspect.rejectChanges();
            this.itemCanceled.emit(this.item);
            this.item = null;
        }
    };
    /**
     * Method called after saving is done.
     */
    FormChildBase.prototype.doneSaving = function (newOrDeleted) {
        var result;
        if (this.item) {
            // To notify relation component to lose selection.
            result = {
                entities: [this.item],
            };
        }
        this.item = null;
        this.itemSaved.emit(result);
    };
    return FormChildBase;
}(FormBase));
export { FormChildBase };
